export function cardLink() {
	document.querySelectorAll('[data-item-link]').forEach((card) => {
		card.addEventListener('click', (event) => {
			if (event.target.closest('a, button')) return

			const selection = window.getSelection()
			if (selection && selection.toString().length) return

			window.location.href = card.dataset.itemLink
		})
	})
}
